module.exports = __webpack_public_path__ + "img/gray-circle-160.eac739d1.png";